import styles from "./index.module.scss";
import { useEffect, useState } from "react";

const ProgressLine = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setProgress((progress) => {
        if (progress + 0.1 > 100) {
          return progress;
        } else if (progress + 0.1 > 80) {
          return progress + 0.1;
        } else if (progress + 0.1 > 60) {
          return progress + 0.5;
        } else {
          return progress + 1;
        }
      });
    }, 10);
  }, [progress]);
  return (
    <div className={styles.cnt}>
      <div
        className={styles.progressLine}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

export default ProgressLine;
